import { createRoot } from 'react-dom/client';
import config from 'config';
import { Notification } from '@schibsted-svp/react-ui';

import { svpApiProxyClient } from 'services';

import { handleClientError } from 'services/client';
import Application from './Application';
import setupStore from './store';
import images from './lib/image';
import device from './lib/device';

const store = setupStore();

images.configure({ ...config.images, getPixelRatio: device.getPixelRatio });

svpApiProxyClient.addEventListener('error', (event) => handleClientError(event, [401]));

const render = (Component) => {
    const root = createRoot(document.getElementById('app'));
    root.render(
        <>
            <Component store={store} />
            <Notification.Container />
        </>
    );
};

render(Application);

if (module.hot) {
    module.hot.accept('./Application', () => {
        render(Application);
    });
}
